import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Title from "../../Title";
import Text from "../../Text";
import ButtonGroups from "../../ButtonGroups";
import Button from "../../Button";
import List from "../../List";
import Image from "../../Image";
import setCurrentPage from "src/Utils/setCurrentPage";
import "./index.css";

interface IntroTemplateProps {
  data: DataIntroTemplate;
}

const IntroTemplate = ({ data }: IntroTemplateProps) => {
  const {
    styleLeftPanel = {},
    bgImage,
    title,
    text,
    listData,
    styleListData = {},
    next,
    back,
    rightSideImage,
    rightSideComponent,
    headerRightText,
    headerLeftImage,
    panelLogo,
    titleStyle,
  } = data;

  const templateType = "intro-template";

  return (
    <BG bgImage={bgImage}>
      <Header
        onClickHome={() => setCurrentPage(1)}
        rightText={headerRightText}
        leftImage={headerLeftImage}
      />
      <Body>
        <div className="intro-container">
          <div className="intro-left-panel" style={styleLeftPanel}>
            <div>
              {panelLogo && (
                <div className="intro-panel-logo">
                  <Image imagePath={panelLogo} />
                </div>
              )}
              <div>
                <Title type={templateType} text={title} style={titleStyle} />
                <Text type={templateType} text={text} />
              </div>
              {listData && (
                <List
                  customStyle={styleListData}
                  type={templateType}
                  listData={listData}
                />
              )}
            </div>
            <ButtonGroups>
              {back && <Button {...back} />}
              {next && <Button {...next} />}
            </ButtonGroups>
          </div>
          <div className="intro-right-panel">
            {rightSideImage && <Image imagePath={rightSideImage} />}
            {rightSideComponent && rightSideComponent}
          </div>
        </div>
      </Body>
    </BG>
  );
};

export default IntroTemplate;
